var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"href":"../static/images/favicon.png","rel":"shortcut icon","type":"image/x-icon"}}),_vm._v(" "),_c('router-view',{attrs:{"user":_vm.user,"user-level":_vm.user_level,"current-project":_vm.current_project},on:{"login":_vm.signInWithGoogle,"set-current-project":_vm.setCurrentProject}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88ee013e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 